import { useCallback, useState } from 'react';
import { useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAuthTokensKey, getLoginKey } from '../../utils/keys';
export const useLogin = () => {
    const queryClient = useQueryClient();
    const { client } = useTribeClient();
    const [isLoading, setLoading] = useState(false);
    const loginKey = getLoginKey();
    const authTokenKey = getAuthTokensKey();
    const login = useCallback(async ({ variables, willReload = false, useQueryOptions, fields = 'default', }) => {
        setLoading(true);
        try {
            const data = await queryClient.fetchQuery(loginKey, () => client === null || client === void 0 ? void 0 : client.auth.login(variables, fields), useQueryOptions);
            // Do not set loading to false and update cache if we're reloading the page right after.
            if (!willReload) {
                queryClient.setQueryData(authTokenKey, data);
                setLoading(false);
            }
            return data;
        }
        catch (error) {
            setLoading(false);
            throw error;
        }
    }, [authTokenKey, client === null || client === void 0 ? void 0 : client.auth, loginKey, queryClient]);
    return {
        login,
        isLoading,
    };
};
//# sourceMappingURL=useLogin.js.map